import { render, staticRenderFns } from "./select.component.vue?vue&type=template&id=36961140&scoped=true"
import script from "./select.component.vue?vue&type=script&lang=js"
export * from "./select.component.vue?vue&type=script&lang=js"
import style0 from "./select.component.vue?vue&type=style&index=0&id=36961140&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36961140",
  null
  
)

export default component.exports